import { useEffect } from 'react';
import { db } from '../firebase';
import { onSnapshot, doc } from 'firebase/firestore';
import useAuthStore from '../stores/authStore';
import useUserStore from '../stores/userStore';

const useUserListener = () => {
    const { user } = useAuthStore();
    const { setAffiliateId, setIsLoading } = useUserStore();

    useEffect(() => {
        if (!user || !user.emailVerified) {
            return;
        }

        const userRef = doc(db, 'users', user.uid);

        const unsubscribe = onSnapshot(userRef, (snapshot) => {
            if (snapshot.exists()) {
                const userData = snapshot.data();
                setAffiliateId(userData.affiliateId || null);
            } else {
                setAffiliateId(null);
            }
            setIsLoading(false);
        });

        return () => unsubscribe();
    }, [user, setAffiliateId, setIsLoading]);
};

export default useUserListener;
